"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoggerForToken = void 0;

var _sumologic = _interopRequireDefault(require("sumologic"));

var _request = _interopRequireDefault(require("request"));

var _package = _interopRequireDefault(require("../package.json"));

var sumoLogicUrl = 'https://endpoint2.collection.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV1WHFuaNbBcT_PtOn9GAl_L1lPRoNvtCXqD-JY03U2l_Tro0QXzjK26bwlKGjTmef_VV3SYhZqaVIgh0c7Fb2tr3XPm8YxN4UvzJedgMM4jVw==';
var opts = {
  request: _request.default,
  endpoint: sumoLogicUrl
};
var logger = new _sumologic.default('', opts);

var initializeLoggger = function initializeLoggger(email) {
  var logPrefix = {
    source_url: window.location.href,
    user_email: email,
    version: _package.default.version
  };
  var originalInfo = logger.info;

  logger.info = function (input, source) {
    logPrefix.message = input;
    logPrefix.source_component = source;
    if (logPrefix.message) originalInfo(logPrefix);
  };

  var originalError = logger.error;

  logger.error = function (input, source) {
    logPrefix.message = input;
    logPrefix.source_component = source;
    if (logPrefix.message) originalError(logPrefix);
  };

  var originalWarn = logger.warn;

  logger.warn = function (input, source) {
    logPrefix.message = input;
    logPrefix.source_component = source;
    if (logPrefix.message) originalWarn(logPrefix);
  };

  return logger;
};

function parseJwt(jwtToken) {
  var base64Url = jwtToken.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(window.atob(base64).replace(/https:\/\/claims.cimpress.io\//g, ''));
}

var getLoggerForToken = function getLoggerForToken(onGetAccesToken) {
  if (process.env.REACT_APP_ENVIRONMENT_NAME === 'Production') {
    var token = onGetAccesToken();
    var parsedValue = token ? parseJwt(token).email : 'unknown';
    return initializeLoggger(parsedValue);
  }

  return console;
};

exports.getLoggerForToken = getLoggerForToken;